TS.ns('WL');

WL.leasingOfferFinancialModel = new Class({
    Extends: WL.leasingOfferBaseModel,

    initialize: function (config) {
        var me = this;

        me.parent(config);

       // me.watchProperty(me.Document.FinancialProductId, me._beforeProductChanged, me, true);

        var monitoredFields = ['BankId', 'ExchangeRate', 'ExchangeRateDate', 'AdvancePercent', 'AdvanceAmount', 'DepositPercent', 'DepositAmount',
            'CommissionPercent', 'CommissionAmount', 'FixedInterestPercent', 'MonthNo', 'Periodicity', 'InterestTypeId',
            'ResidualPercent', 'ResidualAmount', 'CurrencyId', 'VariableInterestPercentDate', 'LeasingOfferAdditionalData.AgreedAnnualMileage'];

        createHandler = function (fieldName) {
            var f = fieldName;
            return function (newValue) {
                me.onOfferInfoChanged(f);
            };
        };

        $.each(monitoredFields, function (idx, fieldName) {
            if (me.Document[fieldName] != undefined) {
                me.watchProperty(me.Document[fieldName], createHandler(fieldName), me);
            }
            else {
                var firstDotPosition = fieldName.indexOf(".");
                if (firstDotPosition > 0) {
                    var leftSide = fieldName.substring(0, firstDotPosition);
                    var rightSide = fieldName.substring(firstDotPosition + 1, fieldName.length);
                    if (me.Document[leftSide][rightSide] != undefined) {
                        me.watchProperty(me.Document[leftSide][rightSide], createHandler(rightSide), me);
                    }
                }
            }
        });

        me.canEditInterestType = ko.computed(
            function () {  
            return me.Document.AdditionalInterestTypeId() == me.VariableAdditionalInterestTypeId() && me.InterestType_IsEditable();
        });

        me.isAdvanceAmountReadOnly = ko.computed(
            function () {
                var percentIsReadOnly = me.AdvancePercent_IsReadOnly();
                var amountIsReadOnly = me.AdvanceAmount_IsReadOnly();

                if (amountIsReadOnly)
                    return true;

                if (percentIsReadOnly)
                    return false;

                var chk = me.Document.PercentageAdvanceYN();
                if (chk != null)
                    return chk;

                return false;
            }
        );

        me.isAdvancePercentReadOnly = ko.computed(
            function () {
                var percentIsReadOnly = me.AdvancePercent_IsReadOnly();
                var amountIsReadOnly = me.AdvanceAmount_IsReadOnly();

                if (percentIsReadOnly)
                    return true;

                if (amountIsReadOnly)
                    return false;

                var chk = me.Document.PercentageAdvanceYN();
                if (chk != null)
                    return !chk;

                return true;
            }
        );

        me.showCessionSection = ko.computed(function () {
            if (me.CessionRestructuringTypes().indexOf(me.Document.OfferTypeId()) > -1)
                return true;
            return false;
        });
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var assetList = me.getDomainProperty('dgLeasingOfferDetailCollection_Property');
        if (assetList != null) {
            assetList.un('cellBeginEdit', me.onAssetGridBeginEdit);
            assetList.on('cellBeginEdit', me.onAssetGridBeginEdit);
            cat = assetList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddAsset';
            newCmd['Text'] = me.AddAssetCommandText();
            newCmd['handler'] = 'onAssetAdded';
            newCmd['IconCode'] = 'plus';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'EditAsset';
            newCmd['Text'] = me.EditAssetCommandText();
            newCmd['handler'] = 'onAssetEdit';
            newCmd['IconCode'] = 'edit';
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'DeleteAsset';
            newCmd['Text'] = me.DeleteAssetCommandText();
            newCmd['handler'] = 'onAssetDeleted';
            newCmd['IconCode'] = 'remove';
            if (!me.ReadOnly())
                cat.push(newCmd);
        }

       var clientList = me.getDomainProperty('browseClient_Property');
       if (clientList != null) {
            clientList.un('selectionChanged', me.onClientChanged, me);
            clientList.on('selectionChanged', me.onClientChanged, me);
       }

        me.watchProperty(me.Document.ClientUniqueIDOnDocument, me.onClientUniqueIDChanged, me);
        
        var contractTypeList = me.getDomainProperty('lkpContractType_Property');
        if (contractTypeList != null) {
            contractTypeList.on('selectionChanged', me.onContractTypeChanged, me);
            contractTypeList.autoSelect = true;
        }

        var currencyList = me.getDomainProperty('lkpCurrency_Property');
        if (currencyList != null) {
            currencyList.on('selectionChanged', me.onCurrencyChanged, me);
        }

        var additionalInterestTypeList = me.getDomainProperty('lkpAdditionalInterestType_Property');
        if (additionalInterestTypeList != null) {
            additionalInterestTypeList.on('selectionChanged', me.onAdditionalInterestTypeChanged, me);
        }

        var scheduleTypeList = me.getDomainProperty('lkpScheduleType_Property');
        if (scheduleTypeList) {
            scheduleTypeList.autoSelect = true;
        }

        var interestTypeList = me.getDomainProperty('lkpInterestType_Property');
        if (interestTypeList) {
            interestTypeList.on('selectionChanged', me.onInterestTypeChanged, me);
            interestTypeList.autoSelect = true;
        }

        var financialProductList = me.getDomainProperty('lkpFinancialProduct_Property');
        if (financialProductList) {
            financialProductList.on('selectionChanged', me.onFinancialProductChanged, me);
            financialProductList.autoSelect = true;
        }
        me.watchProperty(me.Document.PercentageAdvanceYN, me.onPercentageAdvanceYN, me);
    },

    onPercentageAdvanceYN: function () {
        var me = this;
        me.isAdvanceAmountReadOnly();
        me.isAdvancePercentReadOnly();
    },

    onAssetAdded: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'AddAsset',
            submitModel: true,
            blockUI: false
        });
    },

    onAssetEdit: function () {
        var me = this;
        var strings = TS.cultures.current;
        var assetList = me.getDomainProperty('dgLeasingOfferDetailCollection_Property');

        if (assetList.SelectedItem() == null) {
            TS.MsgBox.show(strings.error, strings.list.NoRecordSelected, null);
            return;
        }

        me.performServerCommand({
            cmd: 'EditAsset',
            submitModel: true,
            extraData: { UID: assetList.SelectedItem().UID() },
            blockUI: false
        });
    },

    onAssetGridBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        e.preventDefault();
        if (e.fieldName == 'ItemName')
            owner.onAssetEdit();
    },

    onAssetDeleted: function () {
        var me = this;

        var assetList = me.getDomainProperty('dgLeasingOfferDetailCollection_Property');

        if (assetList.SelectedItem() == null)
            return;

        me.performServerCommand('DeleteAsset', true, { UID: assetList.SelectedItem().UID() });
    },

    onClientChanged: function (selectedPartner) {
        var me = this;

        me.isPartnerChanging = true;

        if (selectedPartner.sender.SelectedItem() == null) {
            me.Document.PartnerTypeId(null);
            me.Document.PartnerTypeName(null);
            me.Document.ClientUniqueIDOnDocument(null);
        }
        else {
            setTimeout(function () {
                me.Document.PartnerTypeId(selectedPartner.sender.SelectedItem().PartnerTypeId);
                me.Document.PartnerTypeName(selectedPartner.sender.SelectedItem().PartnerTypeName);
                me.Document.ClientUniqueIDOnDocument(selectedPartner.sender.SelectedItem().UniqueID);
                me.Document.ClientNameOnDocument(null);
            }, 0);
        }

        me.isPartnerChanging = false;
    },

    onClientUniqueIDChanged: function (newValue) {
        var me = this;

        if (me.isPartnerChanging === true)
            return;

        me.performServerCommand('SearchPartner', true);
    },

    onContractTypeChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("ContractType");
    },

    onCurrencyChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("Currency");
    },

    onAdditionalInterestTypeChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("AdditionalInterestType");
    },

    onInterestTypeChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("InterestType");
    },


    onFinancialProductChanged: function (newValue) {
        var me = this;

        me.onOfferInfoChanged("FinancialProduct");
    },

    onOfferInfoChanged: function (fieldName) {
        var me = this;

        if (me.InsideOfferInfoChanged === true || me.settingData === true)
            return;

        me.InsideOfferInfoChanged = true;

        me.performServerCommand(
            {
                cmd: 'ComputeFinancialInformation',
                submitModel: true,
                extraData: { fieldName: fieldName },
                callback: function () {
                    me.InsideOfferInfoChanged = false;
                }
            });
    },

    _setData: function (data) {
        var me = this;
        try {
            me.settingData = true;
            me.parent(data);
        }
        finally {
            me.settingData = false;
        }

    }

});

